/* Romano's necklace builder — chain and charm illustrations (used until real photos are added).
   Charms are drawn in a 60x60 box. anchor() says where each one meets the chain and whether it
   turns with the chain. Letters and pearls are threaded on; set stones are joined to the chain by their claws.
   Stones with a photo use the photo; the drawings below are the fallback. */
window.RNB_ART = (function(){
  var uid = 0;
  function id(p){ return 'rnba-' + p + '-' + (++uid); }
  function f(n){ return Math.round(n * 100) / 100; }
  function pt(cx, cy, r, deg){ var a = (deg - 90) * Math.PI / 180; return [f(cx + r * Math.cos(a)), f(cy + r * Math.sin(a))]; }
  function poly(pts, fill, op){ return '<polygon points="' + pts.map(function(p){ return p.join(','); }).join(' ') + '" fill="' + fill + '"' + (op != null ? ' fill-opacity="' + op + '"' : '') + '/>'; }

  function metalDefs(m, g){
    return '<linearGradient id="' + g + '" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + m.light + '"/><stop offset=".45" stop-color="' + m.mid + '"/><stop offset="1" stop-color="' + m.dark + '"/></linearGradient>';
  }
  function shadowDefs(sh){
    return '<filter id="' + sh + '" x="-30%" y="-30%" width="160%" height="170%"><feDropShadow dx="0" dy="1.2" stdDeviation="1" flood-color="#3a2e1f" flood-opacity=".25"/></filter>';
  }
  function stoneDefs(c, s){
    if (c.color === 'diamond') return '<radialGradient id="' + s + '" cx=".38" cy=".32" r=".85"><stop offset="0" stop-color="#ffffff"/><stop offset=".55" stop-color="#e6ebf1"/><stop offset="1" stop-color="#aeb9c4"/></radialGradient>';
    if (c.shape === 'opal') return '<radialGradient id="' + s + '" cx=".4" cy=".35" r=".85"><stop offset="0" stop-color="#f7fbff"/><stop offset=".35" stop-color="#cfe9f0"/><stop offset=".7" stop-color="#b9c8ef"/><stop offset="1" stop-color="#9fb6d9"/></radialGradient>';
    if (c.shape === 'pearl') return '<radialGradient id="' + s + '" cx=".36" cy=".3" r=".8"><stop offset="0" stop-color="#ffffff"/><stop offset=".5" stop-color="#f6f1e8"/><stop offset=".82" stop-color="#e6dbc9"/><stop offset="1" stop-color="#c9b99f"/></radialGradient>';
    return '<radialGradient id="' + s + '" cx=".38" cy=".32" r=".85"><stop offset="0" stop-color="#ffffff" stop-opacity=".7"/><stop offset=".3" stop-color="' + c.color + '"/><stop offset="1" stop-color="' + c.color + '"/></radialGradient>';
  }

  /* ---------- Cable chain: alternating face-on and side-on oval links along a polyline ---------- */
  function links(points, m, sp){
    sp = sp || 4.6;
    var out = '', shadow = 'M' + points.map(function(p){ return f(p[0]) + ' ' + f(p[1] + 1.3); }).join(' L');
    out += '<path d="' + shadow + '" fill="none" stroke="#3a2e1f" stroke-opacity=".12" stroke-width="2.6" stroke-linejoin="round"/>';
    var carry = 0, k = 0;
    for (var i = 0; i < points.length - 1; i++){
      var a = points[i], b = points[i + 1], dx = b[0] - a[0], dy = b[1] - a[1], len = Math.sqrt(dx * dx + dy * dy);
      if (!len) continue;
      var ang = f(Math.atan2(dy, dx) * 180 / Math.PI), d = carry;
      for (; d < len; d += sp, k++){
        var x = f(a[0] + dx * d / len), y = f(a[1] + dy * d / len), rot = ' transform="rotate(' + ang + ' ' + x + ' ' + y + ')"';
        if (k % 2 === 0){
          out += '<ellipse cx="' + x + '" cy="' + y + '" rx="2.9" ry="1.9"' + rot + ' fill="none" stroke="' + m.dark + '" stroke-width="1.35"/>' +
                 '<ellipse cx="' + x + '" cy="' + y + '" rx="2.9" ry="1.9"' + rot + ' fill="none" stroke="' + m.mid + '" stroke-width=".85"/>' +
                 '<path d="M' + f(x - 1.6) + ' ' + f(y - 1.2) + ' q1.6 -1 3.2 0"' + rot + ' fill="none" stroke="' + m.light + '" stroke-width=".5"/>';
        } else {
          out += '<line x1="' + f(x - 2.6) + '" y1="' + y + '" x2="' + f(x + 2.6) + '" y2="' + y + '"' + rot + ' stroke="' + m.dark + '" stroke-width="1.5" stroke-linecap="round"/>' +
                 '<line x1="' + f(x - 2.2) + '" y1="' + f(y - .2) + '" x2="' + f(x + 2.2) + '" y2="' + f(y - .2) + '"' + rot + ' stroke="' + m.light + '" stroke-width=".6" stroke-linecap="round"/>';
        }
      }
      carry = d - len;
    }
    return out;
  }

  /* ---------- Settings ---------- */
  function claw(x, y, rad, g, m){
    return '<circle cx="' + x + '" cy="' + y + '" r="' + rad + '" fill="url(#' + g + ')" stroke="' + m.dark + '" stroke-width=".35"/>' +
           '<circle cx="' + f(x - rad * .3) + '" cy="' + f(y - rad * .35) + '" r="' + f(rad * .35) + '" fill="#fff" opacity=".6"/>';
  }

  /* Round stone attachment points: loops on the two top claws (at 10 and 2 o'clock) */
  function roundGeom(k){
    var r = 10.5 * k, L = pt(30, 30, r * .97, 315), R = pt(30, 30, r * .97, 45), o = 1.9 * k + 1.6;
    return { A: [f(L[0] - o * .7), f(L[1] - o * .7)], B: [f(R[0] + o * .7), f(R[1] - o * .7)] };
  }

  /* Faceted round: octagonal table showing a starburst of pavilion facets, star and bezel facets on the crown,
     upper-girdle facets at the edge. Fixed light/dark pattern gives strong, crisp contrast. */
  function brilliant(cx, cy, r){
    var T = [], M = [], G = [], i, o = '', edge = ' stroke="#fff" stroke-opacity=".28" stroke-width=".22" stroke-linejoin="round"';
    for (i = 0; i < 8; i++){ T.push(pt(cx, cy, r * .56, i * 45 + 22.5)); M.push(pt(cx, cy, r * .8, i * 45)); }
    for (i = 0; i < 16; i++) G.push(pt(cx, cy, r * .99, i * 22.5));
    var tone = function(pts, v){ return '<polygon points="' + pts.map(function(p){ return p.join(','); }).join(' ') + '" fill="' + (v > 0 ? '#fff' : '#000') + '" fill-opacity="' + Math.abs(v) + '"' + edge + '/>'; };
    var gird = [.45, -.3, .15, -.12, .5, -.38, .2, -.08, .35, -.25, .55, -.2, .1, -.35, .3, -.15];
    var bez = [-.32, .48, -.1, .28, -.4, .52, -.18, .2];
    var star = [.3, -.22, .55, -.28, .18, -.35, .42, -.12];
    var ray = [.5, -.18, .22, -.34, .6, -.1, .3, -.28, .45, -.22, .15, -.36, .55, -.14, .28, -.3];
    for (i = 0; i < 8; i++){
      var n = (i + 1) % 8;
      o += tone([M[i], G[2 * i], G[2 * i + 1]], gird[2 * i]) + tone([M[n], G[2 * i + 1], G[(2 * i + 2) % 16]], gird[2 * i + 1]);
      o += tone([M[i], T[i], M[n], G[2 * i + 1]], bez[i]);
      o += tone([T[(i + 7) % 8], T[i], M[i]], star[i]);
    }
    /* table: base, then pavilion starburst seen through it */
    o += tone(T, .08);
    for (i = 0; i < 8; i++){
      var n2 = (i + 1) % 8, mid = [f((T[i][0] + T[n2][0]) / 2), f((T[i][1] + T[n2][1]) / 2)];
      o += tone([[cx, cy], T[i], mid], ray[2 * i]) + tone([[cx, cy], mid, T[n2]], ray[2 * i + 1]);
    }
    o += '<circle cx="' + f(cx - r * .3) + '" cy="' + f(cy - r * .42) + '" r="' + f(r * .1) + '" fill="#fff" opacity=".9"/>';
    return o;
  }

  /* Round brilliant in 4 claws, joined to the chain by its two top claws (opal keeps its colour flashes under the facets) */
  function round(c, m, g, s, k){
    var r = 10.5 * k, cx = 30, cy = 30;
    var out = '<circle cx="' + cx + '" cy="' + f(cy) + '" r="' + f(r + 1) + '" fill="url(#' + g + ')"/>' +
              '<circle cx="' + cx + '" cy="' + f(cy) + '" r="' + f(r) + '" fill="url(#' + s + ')"/>';
    if (c.shape === 'opal'){
      out += '<ellipse cx="' + f(cx - r * .3) + '" cy="' + f(cy + r * .1) + '" rx="' + f(r * .35) + '" ry="' + f(r * .22) + '" fill="#7fe0b5" opacity=".55"/>' +
             '<ellipse cx="' + f(cx + r * .28) + '" cy="' + f(cy - r * .2) + '" rx="' + f(r * .3) + '" ry="' + f(r * .2) + '" fill="#f6a98c" opacity=".5"/>' +
             '<ellipse cx="' + f(cx + r * .15) + '" cy="' + f(cy + r * .4) + '" rx="' + f(r * .32) + '" ry="' + f(r * .16) + '" fill="#8f7cf0" opacity=".45"/>';
    }
    out += brilliant(cx, cy, r);
    var cr = f(1.9 * k + .4);
    [45, 135, 225, 315].forEach(function(d){ var p = pt(cx, cy, r * .97, d); out += claw(p[0], p[1], cr, g, m); });
    var G = roundGeom(k);
    return loop(G.A, 0, m, g) + loop(G.B, 0, m, g) + out;
  }
  function loop(p, ang, m, g){
    var r = ' transform="rotate(' + f(ang) + ' ' + p[0] + ' ' + p[1] + ')"';
    return '<ellipse cx="' + p[0] + '" cy="' + p[1] + '" rx="2.6" ry="1.9"' + r + ' fill="none" stroke="' + m.dark + '" stroke-width="1.5"/>' +
           '<ellipse cx="' + p[0] + '" cy="' + p[1] + '" rx="2.6" ry="1.9"' + r + ' fill="none" stroke="url(#' + g + ')" stroke-width="1"/>';
  }

  /* Pear attachment points: A = loop on the top round-end claw, B = loop on the tip of the V-claw */
  function pearGeom(k){
    var L = 29 * k, W = 18 * k, x0 = 30 - L * .5, x1 = 30 + L * .5;
    var A = [f(x0 + L * .14 - 2.6), f(30 - W * .4 - 1.6)], B = [f(x1 + 3.6), 30];
    return { A: A, B: B, ang: Math.atan2(B[1] - A[1], B[0] - A[0]) * 180 / Math.PI, half: Math.sqrt(Math.pow(B[0] - A[0], 2) + Math.pow(B[1] - A[1], 2)) / 2 };
  }

  /* Pear in 3 claws (V-claw on the point, two on the round end); the chain joins the top round-end claw and the point */
  function pear(c, m, g, s, k){
    var L = 29 * k, W = 18 * k, cx = 30, cy = 30;
    var x0 = cx - L * .5, x1 = cx + L * .5;
    var shape = function(sc){
      var l = L * sc, w = W * sc, a = cx - l * .5, b = cx + l * .5;
      return 'M' + f(b) + ' ' + f(cy) +
        ' C' + f(b - l * .2) + ' ' + f(cy - w * .2) + ' ' + f(a + l * .45) + ' ' + f(cy - w * .62) + ' ' + f(a + l * .22) + ' ' + f(cy - w * .5) +
        ' C' + f(a - l * .02) + ' ' + f(cy - w * .4) + ' ' + f(a - l * .02) + ' ' + f(cy + w * .4) + ' ' + f(a + l * .22) + ' ' + f(cy + w * .5) +
        ' C' + f(a + l * .45) + ' ' + f(cy + w * .62) + ' ' + f(b - l * .2) + ' ' + f(cy + w * .2) + ' ' + f(b) + ' ' + f(cy) + 'Z';
    };
    var out = '<path d="' + shape(1.08) + '" fill="url(#' + g + ')"/><path d="' + shape(1) + '" fill="url(#' + s + ')"/>';
    var tx = cx - L * .1;
    var tbl = [[f(tx - L * .2), f(cy)], [f(tx), f(cy - W * .2)], [f(tx + L * .28), f(cy)], [f(tx), f(cy + W * .2)]];
    var edge = [[f(x0 + 1), f(cy)], [f(x0 + L * .3), f(cy - W * .47)], [f(x0 + L * .7), f(cy - W * .3)], [f(x1 - 1), f(cy)], [f(x0 + L * .7), f(cy + W * .3)], [f(x0 + L * .3), f(cy + W * .47)]];
    out += poly([tbl[1], edge[1], tbl[0]], '#fff', .3) + poly([tbl[1], edge[2], tbl[2]], '#000', .08) + poly([tbl[3], edge[4], tbl[2]], '#000', .14) +
           poly([tbl[3], edge[5], tbl[0]], '#fff', .1) + poly([tbl[0], edge[0], edge[1]], '#fff', .18) + poly([tbl[0], edge[5], edge[0]], '#000', .06) +
           poly([tbl[2], edge[3], edge[2]], '#fff', .12) + poly([tbl[2], edge[4], edge[3]], '#000', .1) + poly(tbl, '#fff', .2);
    out += '<circle cx="' + f(x0 + L * .28) + '" cy="' + f(cy - W * .2) + '" r="' + f(1.5 * k) + '" fill="#fff" opacity=".85"/>';
    var v = 4.2 * k;
    out += '<path d="M' + f(x1 - v) + ' ' + f(cy - v * .75) + ' L' + f(x1 + 1.6) + ' ' + f(cy) + ' L' + f(x1 - v) + ' ' + f(cy + v * .75) + ' L' + f(x1 - v * .45) + ' ' + f(cy) + 'Z" fill="url(#' + g + ')" stroke="' + m.dark + '" stroke-width=".35"/>';
    var cr = f(1.9 * k + .4);
    out += claw(f(x0 + L * .14), f(cy - W * .4), cr, g, m) + claw(f(x0 + L * .14), f(cy + W * .4), cr, g, m);
    /* connector loops on the top claw and on the tip of the V-claw, turned to follow the chain */
    var G = pearGeom(k);
    return loop(G.A, G.ang, m, g) + loop(G.B, G.ang, m, g) + out;
  }

  /* Pearl drilled through the middle and threaded onto the chain */
  function pearl(c, m, g, s, k){
    var r = 8.5 * k;
    return '<circle cx="30" cy="30" r="' + f(r) + '" fill="url(#' + s + ')"/>' +
      '<ellipse cx="' + f(30 - r * .32) + '" cy="' + f(30 - r * .4) + '" rx="' + f(r * .3) + '" ry="' + f(r * .2) + '" fill="#fff" opacity=".85"/>' +
      '<ellipse cx="' + f(30 + r * .3) + '" cy="' + f(30 + r * .45) + '" rx="' + f(r * .45) + '" ry="' + f(r * .22) + '" fill="#e9d9df" opacity=".35"/>';
  }

  /* Initial threaded through its top onto the chain: clean sans-serif, polished flat face */
  function letter(c, m, g){
    var t = function(dx, dy, fill, extra){
      return '<text x="' + f(30 + dx) + '" y="' + f(31 + dy) + '" text-anchor="middle" font-family="Futura, Century Gothic, Avenir Next, Helvetica Neue, Arial, sans-serif" font-size="31" font-weight="500" fill="' + fill + '"' + (extra || '') + '>' + c.letter + '</text>';
    };
    return t(.6, .8, m.dark, ' opacity=".9"') + t(0, 0, 'url(#' + g + ')', ' stroke="' + m.dark + '" stroke-width=".3"') + t(-.3, -.35, '#fff', ' opacity=".16"');
  }

  /* ---------- Photo charms ----------
     Cut-out product photos (theme assets nb-<stone>-<yg|wg>.webp). PHOTO gives each photo set's placement in the
     60x60 box and the two points where the chain joins the claws (A, B). */
  var photoBase = '';
  var PHOTO = {
    'round':        { x: 17.41, y: 17.49, w: 25.14, h: 25.14, A: [21.03, 21.1], B: [38.64, 21.1] },
    'pear-diamond': { x: 13.57, y: 18.31, w: 33.1,  h: 24.3,  A: [18.49, 21.84], B: [43.39, 29.54] },
    'pear-lab':     { x: 13.09, y: 17.93, w: 33.1,  h: 24.3,  A: [16.96, 20.75], B: [44.0, 30.42] },
    'pearl':        { x: 20.49, y: 20.77, w: 18.96, h: 18.96 }
  };
  function usePhoto(c){ return !!(photoBase && c.photo && PHOTO[c.pshape]); }
  function sc(v, k){ return f(30 + (v - 30) * k); }
  function photoPts(c){
    var P = PHOTO[c.pshape], k = c.scale || 1;
    return P.A ? { A: [sc(P.A[0], k), sc(P.A[1], k)], B: [sc(P.B[0], k), sc(P.B[1], k)] } : null;
  }
  function photoSVG(c, m, g){
    var P = PHOTO[c.pshape], k = c.scale || 1, pts = photoPts(c), out = '';
    var file = photoBase + 'nb-' + c.photo + '-' + (c.pshape === 'pearl' ? 'all' : (m.photo || 'yg')) + '.webp';
    if (pts){
      var ang = Math.atan2(pts.B[1] - pts.A[1], pts.B[0] - pts.A[0]) * 180 / Math.PI;
      out += loop(pts.A, ang, m, g) + loop(pts.B, ang, m, g);
    }
    return out + '<image href="' + file + '" x="' + sc(P.x, k) + '" y="' + sc(P.y, k) + '" width="' + f(P.w * k) + '" height="' + f(P.h * k) + '" preserveAspectRatio="none"/>';
  }

  /* Where each charm meets the chain (in its own 60x60 box) */
  function anchor(c){
    if (c.shape === 'letter') return { x: 30, y: 9, follow: true };
    if (usePhoto(c)){
      var q = photoPts(c);
      if (!q) return { x: 30, y: 30, follow: true };
      return { x: f((q.A[0] + q.B[0]) / 2), y: f((q.A[1] + q.B[1]) / 2), follow: true,
               span: f(Math.sqrt(Math.pow(q.B[0] - q.A[0], 2) + Math.pow(q.B[1] - q.A[1], 2)) / 2),
               tilt: f(Math.atan2(q.B[1] - q.A[1], q.B[0] - q.A[0]) * 180 / Math.PI) };
    }
    if (c.shape === 'pear'){
      var G = pearGeom(c.scale || 1);
      return { x: f((G.A[0] + G.B[0]) / 2), y: f((G.A[1] + G.B[1]) / 2), follow: true, span: f(G.half), tilt: f(G.ang) };
    }
    if (c.shape === 'pearl') return { x: 30, y: 30, follow: true };
    var R = roundGeom(c.scale || 1);
    return { x: f((R.A[0] + R.B[0]) / 2), y: R.A[1], follow: true, span: f((R.B[0] - R.A[0]) / 2), tilt: 0 };
  }

  function charmSVG(c, m, standalone){
    var g = id('m'), s = id('s'), sh = id('sh'), k = c.scale || 1, body;
    var defs = metalDefs(m, g) + shadowDefs(sh);
    if (c.shape === 'letter') body = letter(c, m, g);
    else if (usePhoto(c)) body = photoSVG(c, m, g);
    else {
      defs += stoneDefs(c, s);
      body = c.shape === 'pear' ? pear(c, m, g, s, k) : c.shape === 'pearl' ? pearl(c, m, g, s, k) : round(c, m, g, s, k);
    }
    var inner = '<defs>' + defs + '</defs><g filter="url(#' + sh + ')">' + body + '</g>';
    if (!standalone) return inner;
    var a = anchor(c), top = c.shape === 'letter' ? -6 : 8;
    if (a.tilt) inner = '<g transform="rotate(' + (-a.tilt) + ' ' + a.x + ' ' + a.y + ')">' + inner + '</g>';
    return '<svg viewBox="8 ' + top + ' 44 44" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' + links([[0, a.y], [60, a.y]], m) + inner + '</svg>';
  }

  return { charmSVG: charmSVG, anchor: anchor, links: links, setPhotoBase: function(u){ photoBase = u || ''; } };
})();
